import { useLoggedInHasJira } from "@/components/user-context/helpers/cohorts";
import {
    filterAvailableJiraSites,
    type UserProfileExistingSites
} from "@/templates/software/jira/logged-in/utils/use-recent-jira-site";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { ActivationChecklistExperimentPlacement } from "./activation-checklist-placement";

type ActivationChecklistLoggedInHeroPlacementProps = {
    siteUrl: string;
    cloudSiteId?: string;
    recentWorkUrl?: string;
    existingSites?: UserProfileExistingSites[];
};

export const ActivationChecklistLoggedInHeroPlacement = ({
    siteUrl,
    cloudSiteId,
    recentWorkUrl,
    existingSites
}: ActivationChecklistLoggedInHeroPlacementProps) => {
    const gateEnabled = checkFeatureFlagGate(
        featureFlags.jiraWacActivationChecklistGate
    );
    const loggedInHasJira = useLoggedInHasJira();

    if (gateEnabled !== true || loggedInHasJira !== true) {
        return null;
    }

    const jiraSite = filterAvailableJiraSites(existingSites).find(
        (site) => site.cloudId === cloudSiteId
    );
    const hasJiraTarget = Boolean(siteUrl && cloudSiteId);

    return (
        <ActivationChecklistExperimentPlacement
            siteUrl={hasJiraTarget ? siteUrl : undefined}
            cloudSiteId={hasJiraTarget ? cloudSiteId : undefined}
            recentWorkUrl={hasJiraTarget ? recentWorkUrl : undefined}
            canInviteTeam={jiraSite?.hasAdminAccess === true}
        />
    );
};

ActivationChecklistLoggedInHeroPlacement.displayName =
    "ActivationChecklistLoggedInHeroPlacement";
